import { createColumnHelper } from '@tanstack/react-table'

export const useCreateTable = <T extends object>() => createColumnHelper<T>()
